export const contextMap: Record<string, string> = {
  "/billing": "billing/overview",
  "/rebalances": "trading/overview",
  "/models": "trading/overview",
  "/firm/risk/asset-class": "firm/risk-asset-class",
  "/firm/risk/security-category": "firm/risk-security-category",
  "/firm/risk": "firm/risk",
  "/firm/security-master": "firm/security-master",
  "/firm/trades/minimum-size": "firm/trades-minimum-size",
  "/firm": "firm/overview",
  "/clients/contacts": "clients/contacts",
  "/clients/households/mapping": "clients/household-data-connections",
  "/clients/households": "clients/households",
  "/clients/accounts/mapping": "clients/accounts-mapping",
  "/clients": "clients/overview",
  "/dashboard": "getting-started/welcome",
};

/**
 * The help article for the page at `path`: the entry of {@link contextMap}
 * with the longest prefix of `path`, so the order of the entries does not
 * matter.
 */
export function contextArticleFor(path: string): string | undefined {
  return Object.entries(contextMap)
    .sort((a, b) => b[0].length - a[0].length)
    .find(([prefix]) => path.startsWith(prefix))?.[1];
}
